import { useEffect, useRef, useState } from 'react'
import CreateButton from '../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton';
import CRUDTable from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable';
import CRUDTableHeader from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader';
import CRUDth from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth';
import ViewButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton';
import EditButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/EditButton/EditButton';
// import DeleteButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/DeleteButton/DeleteButton';
import ShortTextCell from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell';
import CRUDTableRow from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow';
import Modal from '../../../../Partials/Elements/Modal/Modal';
import CreateSocialLinks from './CreateSocialLinks';
import ViewSocialLinks from './ViewSocialLinks';
import useAxiosInstance from '../../../../../Utilities/Hooks/useAxiosInstance';
// import DeleteItem from '../../../../Partials/Layouts/DeleteItem/DeleteItem';
import UpdateSocialLinks from './UpdateSocialLinks';
import { SOCIALLINKS_API } from '../../../../../Utilities/APIs/APIs';


function SocialLinks() {

  const axiosInstance = useAxiosInstance()

  const [sociallinks, setSocialLinks] = useState(null)
  const screenHeaerRef = useRef()
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight)
  }, [screenHeaerRef]);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  // const [showDeleteSection, setShowDeleteSection] = useState(false)
  const [toggleFetch, setToggleFetch] = useState(false)

  const [targetID, setTargetID] = useState(null)

  useEffect(() => {

  async function fetchAndsetsetSocialLinks() {
      const { data } = await axiosInstance.get(SOCIALLINKS_API)
      setSocialLinks(data)
    }
    fetchAndsetsetSocialLinks()

  }, [toggleFetch, axiosInstance])

  function triggerFetch() {
    setToggleFetch(prevState => !prevState)
  }
  return (
    <>
      <div className='screen_header' ref={screenHeaerRef}>
        <h1 className='screen_heading'>SocialLinks ({sociallinks?.length}  in total)</h1>
        <CreateButton
          screenTopicSingular={'SocialLinks'}
          setShowCreateForm={setShowCreateForm}
        /> 
      </div>
      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th='Title' />
          <CRUDth th='Link' />
          <CRUDth th='Actions' />
        </CRUDTableHeader>
        <tbody>
          {
            sociallinks?.map(sociallink =>
              <CRUDTableRow key={sociallink._id}>
                <ShortTextCell text={sociallink.platform} />
                <ShortTextCell text={sociallink.link} />
                <td>
                  <div className="action_buttons_wrapper">
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={sociallink._id}
                        setTargetID={setTargetID}
                        tooltipName={"View"} 
                        tooltipContent={"View"}
                      />

                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={sociallink._id}
                        setTargetID={setTargetID}
                        tooltipName={"Edit"} 
                        tooltipContent={"Edit"}
                      />

                      {/* <DeleteButton
                        setShowDeleteSection={setShowDeleteSection}
                        targetID={sociallink._id}
                        setTargetID={setTargetID}
                      /> */}
                    </div>
                  </div>
                </td>
              </CRUDTableRow>

            )
          }
        </tbody>
      </CRUDTable>
      {

        showCreateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Add SocialLink`}
          setShowModalContent={setShowCreateForm}
        >
          <CreateSocialLinks
            triggerFetch={triggerFetch}
            setShowCreateForm={setShowCreateForm}
          />
        </Modal>
  
      }
      {
        showUpdateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Update SocialLink`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateSocialLinks
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={setShowUpdateForm}
          />
        </Modal>
      }
      {
        showViewSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`View SocialLink`}
          setShowModalContent={setShowViewSection}
        >
          <ViewSocialLinks
            targetID={targetID}
          />
        </Modal>
      }
      {/* {
        showDeleteSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`Delete SocialLink`}
          setShowModalContent={setShowDeleteSection}
        >
          <DeleteItem
            api={SOCIALLINKS_API}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowDeleteItem={setShowDeleteSection}
          />
        </Modal>
      } */}
    </>
  )
}

export default SocialLinks